import cx from 'classnames';

export const reviewStateClass = (review_state, baseClass = '') =>
  cx(baseClass, {
    [`review-state-${review_state}`]:
      review_state && review_state !== 'published',
  });
